function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { CardBuilder } from "./Helpers/CardBuilder";
import { CommonBuilder } from "./Helpers/CommonBuilder"; //Shared:

import { ComponentBase } from "./Shared/ComponentBase";
import { CustomFormBuilder } from "./Helpers/CustomFormBuilder"; //Helpers:

import { DateTimeFormatter } from "./Helpers/DateTimeFormatter";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { ModalBuilder } from "./Helpers/ModalBuilder"; //Services:

import { EventsApiService } from "./Services/EventsApiService";
import { FormManager } from "./Helpers/FormManager";
import { HouseholdApiService } from "./Services/HouseholdApiService";
import { I18N } from "./Shared/I18n";
import { ICSCalendarBuilder } from "./Helpers/ICSCalendarBuilder";
import { InnerPageBuilder } from "./Helpers/InnerPageBuilder";
import { NumberUtils } from "./Helpers/NumberUtils";
import { OAuthService } from "./Services/OAuthService";
import { ProductFormBuilder } from "./Helpers/ProductFormBuilder";
import { ProductsApiService } from "./Services/ProductsApiService";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { UrlUtils } from "./Shared/UrlUtils";
import { UserService } from "./Services/UserService";
import { CheckoutApiService } from "./Services/CheckoutApiService";
import { Configuration } from "./Shared/Configuration";
export var MppEventDetails = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppEventDetails, _ComponentBase);

  var _super = _createSuper(MppEventDetails);

  function MppEventDetails() {
    _classCallCheck(this, MppEventDetails);

    return _super.call(this);
  }

  _createClass(MppEventDetails, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _mppWidgetsConfigValu,
            _mppWidgetsConfigValu2,
            _this = this;

        var mppWidgetsConfigValues, _this$_userInfo;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.LoadLabels();

              case 2:
                this._i18n = _context.sent;
                this.LoadAttributes();
                _context.next = 6;
                return new Configuration().GetGlobalConfigurationSettingValues();

              case 6:
                mppWidgetsConfigValues = _context.sent;
                this._eventDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.eventDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id";
                this._invoiceDetailWidgetIdParameterName = (_mppWidgetsConfigValu2 = mppWidgetsConfigValues.invoiceDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu2 !== void 0 ? _mppWidgetsConfigValu2 : "id"; //View HTML:

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div id="componentMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="componentMessageText" class="mppw-alert__text"></span></div><div id="emptyContainer"></div><div id="detailsContainer"></div><div id="mapContainer" class="mpp-innerpage--map-container" style="display: none;"><div id="map" class="mpp-innerpage--map"></div><div id="mapAddress" class="mpp-innerpage--map-info"></div></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div id="registrationFormContainer"><div id="spinner"><i class="mppw-spinner"></i></div><div id="eventDetailsContainer" style="display: none;"></div><div id="successMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="successMessageText" class="mppw-alert__text"></span></div><form id="registrationForm" name="registrationForm" class="mppw-form mppw-form-validate" style="display: none;"><div class="titleContainer"><h1>${this._i18n.eventRegistrationHeaderLabel}</h1><h4 id="updateInformationWarningMessage" style="display: none;">${this._i18n.updateInformationWarningMessage}</h4></div><h3 class="mppw-product-description"></h3><div id="eventParticipantsContainer" class="mppw-event-participants-container"></div><input type="hidden" id="EventId" name="EventId"/> <input type="hidden" id="InvoiceId" name="InvoiceId"/> <input type="hidden" id="HouseholdId" name="HouseholdId"/> <input type="hidden" id="IsMinorRegistration" name="IsMinorRegistration"/> <input type="hidden" id="CurrentUserContactId" name="CurrentUserContactId"/> <input type="hidden" id="EventParticipantId" name="EventParticipantId"/> <input type="hidden" id="FormResponseId" name="FormResponseId"/> <input type="hidden" id="ProductId" name="ProductId"/><div id="userHasRegisteredContainer" style="display: none;"><div class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.userHasRegisteredMessage}</span></div></div><div id="priceContainer" style="display: none"><h3 id="singlePriceContainer"><span id="registrationPriceLabel">${this._i18n.registrationPriceLabel} </span><span id="singlePriceValue"></span> <span id="depositPriceContainer" class="mpp-deposit-price-container" style="display: none;">| <span id="depositPriceValue"></span> <span id="depositPriceText"></span></span></h3></div><div id="registerAsContainer" class="mppw-form-field mppw-form-field__static-container" style="display: none"><select name="ContactId" id="registerAs" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="registerAs">${this._i18n.registerAsLabel}*:</label></div><div id="contactInfoForm" style="display: none"><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="firstName" name="FirstName" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.firstNameRequiredMessage}"> <label class="mppw-form-field__label" for="firstName">${this._i18n.firstNameLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="lastName" name="LastName" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.lastNameRequiredMessage}"> <label class="mppw-form-field__label" for="lastName">${this._i18n.lastNameLabel}*:</label></div></div></div><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="email" id="emailAddress" name="EmailAddress" class="mppw-form-field__control" maxlength="255" required data-require-if-blank="MobilePhoneNumber" data-required-message="${this._i18n.phoneOrEmailRequiredMessage}"> <label class="mppw-form-field__label" for="emailAddress">${this._i18n.emailAddressLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="tel" id="mobilePhone" name="MobilePhoneNumber" class="mppw-form-field__control" maxlength="25" required data-require-if-blank="EmailAddress" data-required-message="${this._i18n.phoneOrEmailRequiredMessage}"> <label class="mppw-form-field__label" for="mobilePhone">${this._i18n.phoneNumberLabel}*:</label></div></div></div></div><div id="attendeeInfoForm" style="display: none"><h3>Attendee Information</h3><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="attendeeFirstName" name="attendeeFirstName" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.attendeeFirstNameRequiredMessage}"> <label class="mppw-form-field__label" for="attendeeFirstName">${this._i18n.attendeeFirstNameLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="attendeeLastName" name="attendeeLastName" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.attendeeLastNameRequiredMessage}"> <label class="mppw-form-field__label" for="attendeeLastName">${this._i18n.attendeeLastNameLabel}*:</label></div></div></div><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="date" id="attendeeDateOfBirth" name="attendeeDateOfBirth" class="mppw-form-field__control mppw-form-field_alt-control-ios" required data-invalid-message="" min="1900-01-01" max=""> <label class="mppw-form-field__label" for="attendeeDateOfBirth">${this._i18n.attendeeDateOfBirth}*:</label></div></div></div></div><div id="parentInfoForm" style="display: none"><h3>Parent/Guardian Information</h3><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="parentFirstName" name="parentFirstName" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.parentFirstNameRequiredMessage}"> <label class="mppw-form-field__label" for="parentFirstName">${this._i18n.parentFirstNameLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="parentLastName" name="parentLastName" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.parentLastNameRequiredMessage}"> <label class="mppw-form-field__label" for="parentLastName">${this._i18n.parentLastNameLabel}*:</label></div></div></div><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="email" id="parentEmailAddress" name="parentEmailAddress" class="mppw-form-field__control" maxlength="255" required data-require-if-blank="parentMobilePhoneNumber" data-required-message="${this._i18n.parentPhoneOrEmailRequiredMessage}"> <label class="mppw-form-field__label" for="parentEmailAddress">${this._i18n.parentEmailAddressLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="tel" id="parentMobilePhone" name="parentMobilePhoneNumber" class="mppw-form-field__control" maxlength="25" required data-require-if-blank="parentEmailAddress" data-required-message="${this._i18n.parentPhoneOrEmailRequiredMessage}"> <label class="mppw-form-field__label" for="parentMobilePhone">${this._i18n.parentPhoneNumberLabel}*:</label></div></div></div></div><div id="addressFormWrapper" class="eventDetailsAddress" style="display: none"><h3>Address</h3><div class="mppw-row"><div class="mpp-customform-col-12"><div class="mppw-form-field"><input type="text" id="addressLine1" name="AddressLine1" class="mppw-form-field__control" maxlength="75" required data-required-message="${this._i18n.registrationAddress1Required}"> <label id="addressLine1Label" class="mppw-form-field__label" for="addressLine1">${this._i18n.registrationAddressLabel}</label></div></div></div><div class="mppw-row"><div class="mpp-customform-col-12"><div class="mppw-form-field"><input type="text" id="addressLine2" name="AddressLine2" class="mppw-form-field__control" maxlength="75"> <label class="mppw-form-field__label" for="addressLine2">${this._i18n.registrationAddressLabel2}</label></div></div></div><div class="mppw-row"><div class="mpp-customform-col-4"><div class="mppw-form-field"><input type="text" id="city" name="City" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.registrationCityRequired}"> <label id="cityLabel" class="mppw-form-field__label" for="addressLine1">${this._i18n.registrationCityLabel}</label></div></div><div class="mpp-customform-col-4"><div class="mppw-form-field"><input type="text" id="stateRegion" name="StateRegion" class="mppw-form-field__control" maxlength="50" required data-required-message="${this._i18n.registrationStateRequired}"> <label id="stateLabel" class="mppw-form-field__label" for="addressLine1">${this._i18n.registrationStateLabel}</label></div></div><div class="mpp-customform-col-4"><div class="mppw-form-field"><input type="text" id="postalCode" name="PostalCode" class="mppw-form-field__control" maxlength="15" required data-required-message="${this._i18n.registrationZipCodeRequired}"> <label id="zipCodeLabel" class="mppw-form-field__label" for="addressLine1">${this._i18n.registrationZipCodeLabel}</label></div></div></div></div><div id="productOptionsWrapper" style="display: none"><h3 id="productOptionsTitle"></h3><div id="productOptionsContainer"></div></div><div id="formFields" style="display: none"></div><div id="promoCodeContainer" style="display: none"><h3>${this._i18n.promoCodeLabel}</h3><div class="mppw-form-field"><input type="text" id="promoCodeText"/> <button id="addPromoCodeButton" class="mppw-btn mppw-btn-sm primary">${this._i18n.applyPromoCodeLabel}</button><div id="invalidPromoCode" style="display: none; color: red;">${this._i18n.invalidPromoCodeMessage}</div></div><table id="promoCodeTable" class="promo-code-table" style="display: none;"><thead><tr><th class="promo-code-label">${this._i18n.promoCodeTableHeaderLabel}</th><th class="promo-code-discount-label">${this._i18n.promoDiscountTableHeaderLabel}</th><th class="promo-code-action-label"></th></tr></thead></table></div><div id="updateMyInfoContainer" class="mppw-form-field" style="display: none;"><label class="mpp-card-multiselect--checkbox-small"><input type="checkbox" id="inquire_updateMyInfo" name="updateMyInfo"/> <span style="float: left;"></span></label> <label class="mpp-updatemyinfo--checkboxlabel" for="inquire_updateMyInfo">${this._i18n.updateMyInfoLabel}</label></div><div id="registrationTotalContainer" style="display: none"><h3>${this._i18n.registrationTotalLabel} <span id="registrationTotalValue"></span></h3></div><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div><input type="button" class="mppw-btn primary mpp-mt-10 submit--btn" style="display: none" id="addAnotherButton" value="${this._i18n.addPersonButtonLabel}"/> <input type="button" class="mppw-btn primary mpp-mt-10 submit--btn" style="display: none" id="showAnotherPersonFormButton" value="${this._i18n.addPersonButtonLabel}"/> <input type="button" class="mppw-btn primary mpp-mt-10 submit--btn" style="display: none" id="registerAndCheckoutButton" value="${this._i18n.registerAndCheckoutButtonLabel}"/> <input type="button" class="mppw-btn primary mpp-mt-10 submit--btn" style="display: none" id="saveAndAddAnotherButton" value="${this._i18n.saveAndAddAnotherButtonLabel}"/> <input type="button" class="mppw-btn primary mpp-mt-10 submit--btn" style="display: none" id="saveAndCheckoutButton" value="${this._i18n.saveAndCheckoutButtonLabel}"/> <input type="button" class="mppw-btn primary mpp-mt-10 submit--btn" style="display: none" id="checkoutButton" value="${this._i18n.registerAndCheckoutButtonLabel}"/><div id="errorMessageContainer" style="display: none;"></div></form><div id="registrationNotActiveMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="registrationNotActiveMessageText" class="mppw-alert__text"></span></div></div></div>` ;
                this.BindHtmlElements();
                this._eventService = new EventsApiService();
                this._householdService = new HouseholdApiService();
                this._productsService = new ProductsApiService(); //Get Event

                this.ShowSpinner();
                _context.prev = 15;
                _context.next = 18;
                return this.LoadEventData();

              case 18:
                this._eventData = _context.sent;

                if (!this._eventData) {
                  _context.next = 50;
                  break;
                }

                this._$productId.value = this._eventData.registrationProductId;
                _context.next = 23;
                return this.UserIsAuthenticated();

              case 23:
                this._userIsAuthenticated = _context.sent;
                this._eventStartDate = null;
                this._daysOutToHide = null;
                this._isMinorRegistration = this._eventData.minorRegistration;
                this._$isMinorRegistration.value = this._isMinorRegistration;

                if (!this.IsEventViewable()) {
                  _context.next = 48;
                  break;
                }

                if (!((_this$_userInfo = this._userInfo) !== null && _this$_userInfo !== void 0 && _this$_userInfo.contactId)) {
                  _context.next = 32;
                  break;
                }

                _context.next = 32;
                return this._eventService.GetEventUserContact(this._userInfo.contactId).then(function (userContact) {
                  _this._userContactInfo = userContact;

                  _this.LoadHouseholdInfo();

                  _this._$currentUserContactId.value = userContact.contactId;
                });

              case 32:
                _context.next = 34;
                return this.RenderForms();

              case 34:
                this.DrawEventDetails();

                if (!this.invoiceId) {
                  _context.next = 43;
                  break;
                }

                this._$invoiceId.value = this.invoiceId;
                _context.next = 39;
                return this.UpdateEventParticipants();

              case 39:
                this._$showAnotherPersonFormButton.style.display = "";
                this._$checkoutButton.style.display = "";
                _context.next = 45;
                break;

              case 43:
                this.ShowRegisterAsForm();

                if (!this._userIsAuthenticated) {
                  this.ShowEventRegistrationDataForms();
                  this.ShowUserInfoForms();
                  this._$addAnotherButton.style.display = "";
                }

              case 45:
                //Wire stuff up:
                this.BindEventListeners();
                this._form = new FormManager(this._$registrationForm);

                if (this._eventData.allowEmail) {
                  this.BuildModal();
                }

              case 48:
                _context.next = 51;
                break;

              case 50:
                this.SetMessage("danger", "This event is not available.", false);

              case 51:
                _context.next = 57;
                break;

              case 53:
                _context.prev = 53;
                _context.t0 = _context["catch"](15);
                console.error(_context.t0);
                this.SetMessage("danger", _context.t0.message, false);

              case 57:
                _context.prev = 57;
                this.HideSpinner();
                return _context.finish(57);

              case 60:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[15, 53, 57, 60]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "UpdateEventParticipants",
    value: function () {
      var _UpdateEventParticipants = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedParticipantId,
            clearInvoiceId,
            existingInvoiceResult,
            searchParams,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedParticipantId = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : undefined;
                clearInvoiceId = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
                _context2.next = 4;
                return this._eventService.GetEventParticipantsByInvoice(this._$invoiceId.value);

              case 4:
                existingInvoiceResult = _context2.sent;

                if (!((existingInvoiceResult.isSomePaymentExists || !existingInvoiceResult.participants) && clearInvoiceId)) {
                  _context2.next = 10;
                  break;
                }

                searchParams = new URLSearchParams(window.location.search);
                searchParams["delete"]("invoiceid");
                window.location.search = searchParams.toString();
                return _context2.abrupt("return");

              case 10:
                // Proceed with updating event participants
                this._eventParticipants = existingInvoiceResult.participants;
                this.DrawExistingParticipants(selectedParticipantId);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function UpdateEventParticipants() {
        return _UpdateEventParticipants.apply(this, arguments);
      }

      return UpdateEventParticipants;
    }()
  }, {
    key: "IsEventViewable",
    value: function IsEventViewable() {
      // Determine if event is viewable based on visibility level
      switch (this._eventData.visibilityLevelId) {
        case 1:
          // Private event - not viewable
          this.SetMessage("warning", this._i18n.privateEventMessage, false);
          return false;

        case 2:
          // Staff only event - viewable only if user is staff
          if (this._eventData.isUserStaff) {
            return true;
          } else {
            this.SetMessage("warning", this._i18n.staffOnlyMessage, false);
            return false;
          }

        default:
          // Public event - viewable by all
          return true;
      }
    }
  }, {
    key: "DrawEventDetails",
    value: function DrawEventDetails() {
      this._$detailsContainer.innerHTML = "";
      var dateTimeFormatter = new DateTimeFormatter();
      var isMobile = CommonBuilder.isMobile();
      var _this$_eventData = this._eventData,
          imageUrl = _this$_eventData.imageUrl,
          title = _this$_eventData.title,
          attributes = _this$_eventData.attributes,
          description = _this$_eventData.description,
          opportunityCount = _this$_eventData.opportunityCount,
          location = _this$_eventData.location,
          address = _this$_eventData.address,
          latitude = _this$_eventData.latitude,
          longitude = _this$_eventData.longitude,
          startDate = _this$_eventData.startDate,
          endDate = _this$_eventData.endDate,
          startDateUTC = _this$_eventData.startDateUTC,
          endDateUTC = _this$_eventData.endDateUTC,
          contacts = _this$_eventData.contacts,
          meetingInstructions = _this$_eventData.meetingInstructions,
          externalRegistrationUrl = _this$_eventData.externalRegistrationUrl,
          allowEmail = _this$_eventData.allowEmail,
          rooms = _this$_eventData.rooms,
          showBuildingRoomInfo = _this$_eventData.showBuildingRoomInfo;
      var subtitlesArr = CardBuilder.BuildEventSubtitlesArr(null, startDate, endDate);
      this._eventStartDate = startDate;
      this._$detailsContainer.innerHTML += InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(this._i18n.backToEventSearchLabel, this.returnUrl, ReturnContext.Categories.Events), InnerPageBuilder.BuildFinderDetailImage(imageUrl, "event"), InnerPageBuilder.BuildTitle(title), InnerPageBuilder.BuildLabels(_toConsumableArray(attributes)), InnerPageBuilder.BuildDateTime(subtitlesArr, false), InnerPageBuilder.BuildDescription(description), InnerPageBuilder.BuildContacts(contacts, this._i18n.eventContactLabel, allowEmail), InnerPageBuilder.BuildSpecialText(this._i18n.meetingInstructionsLabel, meetingInstructions));

      if (location != null) {
        this._$detailsContainer.innerHTML += InnerPageBuilder.BuildSpecialText(this._i18n.locationLabel, location);
      }

      if (rooms !== null && showBuildingRoomInfo) {
        var filterDuplicatedRooms = Array.from(new Set(rooms.map(JSON.stringify))).map(JSON.parse);
        var eventRooms = filterDuplicatedRooms.filter(function (_ref) {
          var roomInfo = _ref.roomInfo;
          return !!roomInfo;
        }).map(function (_ref2) {
          var roomInfo = _ref2.roomInfo;
          return roomInfo;
        }).join("<br/>");

        if (eventRooms !== "") {
          this._$detailsContainer.innerHTML += InnerPageBuilder.BuildSpecialText(this._i18n.roomLabel, eventRooms);
        }
      }

      if (isMobile === true) {
        // Show button to bring up Maps application
        if (!!latitude && !!longitude) {
          this._$detailsContainer.innerHTML += InnerPageBuilder.BuildMapAddress(latitude + "," + longitude, false, this._i18n.getDirectionsLabel);
        } // Show button 'Add to Calendar' to download ics file


        this._$detailsContainer.innerHTML += ICSCalendarBuilder.BuildICSHrefString(title, description, location + " - " + address, startDateUTC, endDateUTC);
      } else {
        // Else show map
        if (!!latitude && !!longitude && !!address) {
          // Remove extra text from address string
          var addressOnly = address.replace("Address1:", "").replace("Address2:", "").replace("City, State Zip:", "").replace("Country:", "");
          this._$map.innerHTML = InnerPageBuilder.BuildGoogleMap(this._$map, latitude, longitude, addressOnly, title);
          this._$mapAddress.innerHTML = InnerPageBuilder.BuildMapAddress(addressOnly, true, this._i18n.getDirectionsLabel);
          this._$map.style.display = "";
          this._$mapAddress.style.display = "";
          this._$mapContainer.style.display = "block";
        }
      }

      if (!!externalRegistrationUrl) {
        // Insert after the map container element
        var extRegistrationContainer = document.createElement("div"); // Moved the button next to the ExternalRegistrationUrl button

        if (opportunityCount > 0) {
          var buttonUrl = UrlUtils.AddQueryStringParams(this.opportunityFinderWidgetUrl, {
            eventid: this._$eventId.value
          });
          extRegistrationContainer.innerHTML = InnerPageBuilder.BuildCustomButton(externalRegistrationUrl, this._i18n.externalRegisterButtonLabel) + " " + InnerPageBuilder.BuildCustomButton(buttonUrl, this._i18n.volunteerLabel);
        } else {
          extRegistrationContainer.innerHTML = InnerPageBuilder.BuildCustomButton(externalRegistrationUrl, this._i18n.externalRegisterButtonLabel);
        }

        this._$mapContainer.after(extRegistrationContainer);
      } else {
        // Moved the button below the mapContainer instead of above the location
        if (opportunityCount > 0) {
          var buttonURLContainer = document.createElement("div");

          var _buttonUrl = UrlUtils.AddQueryStringParams(this.opportunityFinderWidgetUrl, {
            eventid: this._$eventId.value
          });

          buttonURLContainer.innerHTML = InnerPageBuilder.BuildCustomButton(_buttonUrl, this._i18n.volunteerLabel);

          this._$mapContainer.after(buttonURLContainer);
        }
      }
    }
  }, {
    key: "UserIsAuthenticated",
    value: function () {
      var _UserIsAuthenticated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return UserService.GetCurrentUser();

              case 3:
                this._userInfo = _context3.sent;
                return _context3.abrupt("return", true);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                this.HideUpdateMyInfoContainer();
                return _context3.abrupt("return", false);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function UserIsAuthenticated() {
        return _UserIsAuthenticated.apply(this, arguments);
      }

      return UserIsAuthenticated;
    }()
  }, {
    key: "ResetProductForm",
    value: function () {
      var _ResetProductForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this$_eventData2, eventId, registrationProductId, forceLogin, registrationActive, isRegistrationFull, externalRegistrationUrl;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$_eventData2 = this._eventData, eventId = _this$_eventData2.eventId, registrationProductId = _this$_eventData2.registrationProductId, forceLogin = _this$_eventData2.forceLogin, registrationActive = _this$_eventData2.registrationActive, isRegistrationFull = _this$_eventData2.isRegistrationFull, externalRegistrationUrl = _this$_eventData2.externalRegistrationUrl;

                if (!(!!registrationActive && !!registrationProductId && registrationProductId > 0)) {
                  _context4.next = 10;
                  break;
                }

                //Show the form:
                this._$registrationForm.style.display = ""; //Render the product form:

                this._$productOptionsContainer.innerHTML = "";
                _context4.next = 6;
                return this.DrawProductForm(registrationProductId, eventId, this.GetSelectedEventParticipantId());

              case 6:
                _context4.next = 8;
                return this.DrawCustomForm();

              case 8:
                _context4.next = 12;
                break;

              case 10:
                //Don't show the form at all:
                this._$registrationForm.style.display = "none";

                if (!!registrationProductId && registrationProductId > 0) {
                  this.SetRegistrationNotActiveMessage();
                } else {
                  this._$registrationNotActiveContainer.style.display = "none";
                }

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ResetProductForm() {
        return _ResetProductForm.apply(this, arguments);
      }

      return ResetProductForm;
    }()
  }, {
    key: "RenderForms",
    value: function () {
      var _RenderForms = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this$_eventData3, eventId, registrationProductId, forceLogin, registrationActive, isRegistrationFull, externalRegistrationUrl;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                //Clear Form:
                this._$productOptionsContainer.innerHTML = "";
                _this$_eventData3 = this._eventData, eventId = _this$_eventData3.eventId, registrationProductId = _this$_eventData3.registrationProductId, forceLogin = _this$_eventData3.forceLogin, registrationActive = _this$_eventData3.registrationActive, isRegistrationFull = _this$_eventData3.isRegistrationFull, externalRegistrationUrl = _this$_eventData3.externalRegistrationUrl;

                if (!externalRegistrationUrl) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                if (!isRegistrationFull) {
                  _context5.next = 7;
                  break;
                }

                this.SetMessage("warning", this._i18n.registrationFullMessage, false);
                return _context5.abrupt("return");

              case 7:
                if (!(!!forceLogin && this._userIsAuthenticated === false)) {
                  _context5.next = 10;
                  break;
                }

                this._$loginButtonContainer.style.display = "";
                return _context5.abrupt("return");

              case 10:
                if (!(!!registrationActive && !!registrationProductId && registrationProductId > 0)) {
                  _context5.next = 20;
                  break;
                }

                //Show the form:
                this._$registrationForm.style.display = "";

                if (this._userInfo) {
                  // Check if user has already registered
                  this.HasUserRegistered(this._userInfo.contactId);
                } //Render the product form:


                _context5.next = 15;
                return this.DrawProductForm(registrationProductId, eventId, this.GetSelectedEventParticipantId());

              case 15:
                _context5.next = 17;
                return this.DrawCustomForm();

              case 17:
                this.UpdateTotal();
                _context5.next = 22;
                break;

              case 20:
                //Don't show the form at all:
                this._$registrationForm.style.display = "none";

                if (!!registrationProductId && registrationProductId > 0) {
                  this.SetRegistrationNotActiveMessage();
                } else {
                  this._$registrationNotActiveContainer.style.display = "none";
                }

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function RenderForms() {
        return _RenderForms.apply(this, arguments);
      }

      return RenderForms;
    }()
  }, {
    key: "DrawProductForm",
    value: function () {
      var _DrawProductForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(registrationProductId, eventId) {
        var eventParticipantId,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                eventParticipantId = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
                _context6.next = 3;
                return this._productsService.GetProduct(registrationProductId, eventId, eventParticipantId);

              case 3:
                this._productData = _context6.sent;

                if (this._productData != null) {
                  this.DrawPrice(this._productData.basePrice, this._productData.depositPrice);

                  if (!!this._productData.description) {
                    this._$productDescription.innerHTML = this._productData.description;
                  } // Set the title of the product options container


                  this._$productOptionsTitle.innerText = this._i18n.addOnsLabel; // Clear only the productOptionsContainer, not the title

                  this._$productOptionsContainer.innerHTML = "";
                  ProductFormBuilder.DrawForm(this._$productOptionsContainer, this._productData, this._i18n); // Bind product options event listeners

                  this.BindProductEventListeners();
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function DrawProductForm(_x, _x2) {
        return _DrawProductForm.apply(this, arguments);
      }

      return DrawProductForm;
    }()
  }, {
    key: "DrawPrice",
    value: function DrawPrice(basePrice, depositPrice) {
      var hasDeposit = depositPrice !== null && depositPrice > 0;
      this._$depositPriceContainer.style.display = hasDeposit ? "" : "none";
      this._$singlePriceContainer.style.display = "";

      if (hasDeposit) {
        this._$singlePriceValue.innerText = "$".concat(basePrice.toFixed(2));
        this._$depositPriceText.innerText = this._i18n.depositDueAtRegistrationLabel;
        this._$depositPriceValue.innerText = "$".concat(depositPrice.toFixed(2));
      } else {
        this._$singlePriceValue.innerText = basePrice === 0 ? this._i18n.freePriceLabel : "$".concat(basePrice.toFixed(2));
      }
    }
  }, {
    key: "DrawCustomForm",
    value: function () {
      var _DrawCustomForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var customFormGuid;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                customFormGuid = this._eventData.customFormGuid; // Display custom form fields

                _context7.next = 3;
                return CustomFormBuilder.RenderCustomForm(customFormGuid, this._$formFields, this._$registrationForm, false, this._userIsAuthenticated);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function DrawCustomForm() {
        return _DrawCustomForm.apply(this, arguments);
      }

      return DrawCustomForm;
    }()
  }, {
    key: "BuildModal",
    value: function BuildModal() {
      var _this$_userInfo$user$, _this$_userInfo2, _this$_userInfo2$user, _this$_userInfo$user$2, _this$_userInfo3, _this$_userInfo3$user;

      this._$detailsContainer.innerHTML += ModalBuilder.BuildSendEmailModal((_this$_userInfo$user$ = (_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : (_this$_userInfo2$user = _this$_userInfo2.user) === null || _this$_userInfo2$user === void 0 ? void 0 : _this$_userInfo2$user.displayName) !== null && _this$_userInfo$user$ !== void 0 ? _this$_userInfo$user$ : "", (_this$_userInfo$user$2 = (_this$_userInfo3 = this._userInfo) === null || _this$_userInfo3 === void 0 ? void 0 : (_this$_userInfo3$user = _this$_userInfo3.user) === null || _this$_userInfo3$user === void 0 ? void 0 : _this$_userInfo3$user.email) !== null && _this$_userInfo$user$2 !== void 0 ? _this$_userInfo$user$2 : "");
      ModalBuilder.BindEmailModalEvents(this._root, this._eventData, this._$resultMessageContainer, this._$resultMessageText, this._userInfo);
    }
  }, {
    key: "LoadHouseholdInfo",
    value: function LoadHouseholdInfo() {
      var _this2 = this;

      if (!this._userInfo) return;
      this._$householdId.value = this._userInfo.householdId;
      return this._householdService.GetHousehold().then(function (household) {
        _this2._members = household.familyMembers;
        _this2._household = household;

        if (!!_this2._members && _this2._members.length > 0) {
          var allMembers = _this2._members.map(function (member) {
            return {
              id: member.contactId,
              value: _this2.GetDisplayName(member),
              disabled: _this2.IsMemberDisabled(member)
            };
          });

          allMembers.unshift({
            id: "Blank Form",
            value: _this2._i18n.registerAsBlankForm
          }); //Load family member dropdown

          DropdownBuilder.LoadDropdown(_this2._$registerAs, allMembers, _this2._i18n.registerAsDefaultLabel);
        } else {
          // Family member data is null so just use contactInfo to populate dropdown
          // Use logged in users contact info to populate dropdowns
          var contactDropdown = [{
            id: _this2._userInfo.contactId,
            value: "".concat(_this2._userInfo.user.lastName, ", ").concat(_this2._userInfo.user.firstName, " ").concat(_this2._userInfo.user.nickName != _this2._userInfo.user.firstName && _this2._userInfo.user.nickName != "" ? "(".concat(_this2._userInfo.user.nickName, ")") : "")
          }];
          contactDropdown.unshift({
            id: "Blank Form",
            value: _this2._i18n.registerAsBlankForm
          }); //Load family member dropdown

          DropdownBuilder.LoadDropdown(_this2._$registerAs, contactDropdown, _this2._i18n.registerAsDefaultLabel);
        }
      });
    }
  }, {
    key: "ResetForm",
    value: function () {
      var _ResetForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this._$promoCodeTable.innerHTML = "";
                this.ResetProductForm(); //Wire stuff up:

                this._form.Dispose();

                this._form = new FormManager(this._$registrationForm); // Reset address and contact form

                this.ResetAddressForm();
                this.ResetContactInfoForm();

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function ResetForm() {
        return _ResetForm.apply(this, arguments);
      }

      return ResetForm;
    }()
  }, {
    key: "ResetFormManually",
    value: function ResetFormManually() {
      //Manually reset form elements:
      var form = this._form;
      this._$promoCodeTable.innerHTML = "";

      this._$registrationForm.reset();

      this.ResetContactInfoForm();
      this.ResetAddressForm(); // Manually reset form element values

      form.ResetFormValues();
      form.SetIsDirty(false); // Re-draw custom form, otherwise depends-on fields will no longer work

      this.DrawCustomForm();
    }
  }, {
    key: "SubmitForm",
    value: function () {
      var _SubmitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(options) {
        var _this$_eventParticipa, checkoutWidgetUrl, eventApiService, formData, isAvailable, response, isRegistrationStillAvailable, _checkoutWidgetUrl;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!options) {
                  _context9.next = 87;
                  break;
                }

                _context9.prev = 1;
                this.DisableSubmitButtons();

                if (!(!this._form._isDirty && ((_this$_eventParticipa = this._eventParticipants) === null || _this$_eventParticipa === void 0 ? void 0 : _this$_eventParticipa.length) > 0 && options.action == "registerAndCheckout" && this._$invoiceId.value)) {
                  _context9.next = 8;
                  break;
                }

                this._form.SetIsDirty(false); //Redirect to checkout widget


                checkoutWidgetUrl = UrlUtils.AddQueryStringParams(this.checkouturl, _defineProperty({}, this._invoiceDetailWidgetIdParameterName, this._$invoiceId.value));
                window.location.href = checkoutWidgetUrl;
                return _context9.abrupt("return", true);

              case 8:
                if (!this._form.IsValid()) {
                  _context9.next = 77;
                  break;
                }

                this._$firstNameText.disabled = false;
                this._$lastNameText.disabled = false;
                this._$attendeeFirstNameText.disabled = false;
                this._$attendeeLastNameText.disabled = false;
                this._$parentFirstNameText.disabled = false;
                this._$parentLastNameText.disabled = false; //Post form data

                eventApiService = new EventsApiService();
                formData = new FormData(this._$registrationForm);
                formData.set("updateMyInfo", this._$updateMyInfo.checked);

                if (formData.get("ContactId") === "Blank Form") {
                  formData["delete"]("ContactId");
                }

                _context9.next = 21;
                return this.LoadEventData();

              case 21:
                this._eventData = _context9.sent;

                if (this.ValidateDateOfBirth()) {
                  _context9.next = 24;
                  break;
                }

                return _context9.abrupt("return", false);

              case 24:
                _context9.next = 26;
                return this.CheckEventAndProductAvailability(formData);

              case 26:
                isAvailable = _context9.sent;

                if (isAvailable) {
                  _context9.next = 29;
                  break;
                }

                return _context9.abrupt("return", false);

              case 29:
                if (this._eventData.isRegistrationFull) {
                  _context9.next = 74;
                  break;
                }

                _context9.next = 32;
                return eventApiService.SaveRegistration(formData);

              case 32:
                response = _context9.sent;

                if (!response.success) {
                  _context9.next = 69;
                  break;
                }

                if (!(options.action == "registerAndAddAnother" || options.action == "saveAndAddAnother")) {
                  _context9.next = 67;
                  break;
                }

                _context9.next = 37;
                return this.ResetForm();

              case 37:
                this.HideUserInfoForms();
                this.HideEventRegistrationDataForms();
                this.ShowRegisterAsForm();
                this._$invoiceId.value = response.guid;

                if (!this._$invoiceId.value) {
                  _context9.next = 47;
                  break;
                }

                _context9.next = 44;
                return this.UpdateEventParticipants(undefined, false);

              case 44:
                this.UpdateParticipantTotal();
                _context9.next = 48;
                break;

              case 47:
                this.UpdateTotal();

              case 48:
                //Adds state to history to be able to go back to the event with specific invoice id when user hits Go Back browser button
                window.history.pushState(null, "Edit Event Details", "?id=".concat(this._eventData.id, "&invoiceid=").concat(this._$invoiceId.value));
                this.SetMessage("success", this._i18n.saveAndAddPersonSuccessMessage, false); // Scroll to top of registration form

                this._$registrationForm.scrollIntoView({
                  behavior: "smooth"
                });

                this._$registerAndCheckoutButton.style.display = "none";
                this._$addAnotherButton.style.display = "none";
                this._$registerAndAddAnotherButton.style.display = "none";
                this._$saveAndCheckoutButton.style.display = "none";
                this._$saveAndAddAnotherButton.style.display = "none";
                this._$checkoutButton.style.display = "";
                this._$eventParticipantId.value = null;
                this._$formResponseId.value = null;
                this._$registerAsContainer.style.display = "none";
                _context9.next = 62;
                return this._eventService.CheckPendingEventAvailability(this._eventData.id);

              case 62:
                isRegistrationStillAvailable = _context9.sent;

                if (isRegistrationStillAvailable) {
                  this._$showAnotherPersonFormButton.style.display = "";

                  if (this._userIsAuthenticated) {
                    this._$registerAsContainer.style.display = "";
                    this._$registerAs.value = "";
                  }
                } else {
                  this.SetMessage("success", this._i18n.saveSuccessMessage, false);
                }

                this.EnableSubmitButtons();
                _context9.next = 68;
                break;

              case 67:
                if (options.action === "registerAndCheckout" || options.action === "saveAndCheckout") {
                  // Since navigating away from page, need to manually set isDirty to false
                  this._form.SetIsDirty(false); //Redirect to checkout widget


                  _checkoutWidgetUrl = UrlUtils.AddQueryStringParams(this.checkouturl, _defineProperty({}, this._invoiceDetailWidgetIdParameterName, response.guid));
                  window.history.pushState(null, "Edit Event Details", "?".concat(this._eventDetailWidgetIdParameterName, "=").concat(this._eventData.id, "&invoiceid=").concat(response.guid));
                  window.location.href = _checkoutWidgetUrl;
                } else if (options.action === "save") {
                  this.UpdateTotal();
                  this._$invoiceId.value = response.guid;
                  this.SetMessage("success", this._i18n.saveSuccessMessage, false);

                  this._form.SetIsDirty(false); // Scroll to top of registration form


                  this._$registrationForm.scrollIntoView({
                    behavior: "smooth"
                  });

                  this.EnableSubmitButtons();
                  this._$registerAs.value = "";
                }

              case 68:
                return _context9.abrupt("return", true);

              case 69:
                this.SetMessage("danger", this._i18n.registrationSaveErrorMessage);
                this.EnableSubmitButtons();
                return _context9.abrupt("return", false);

              case 74:
                this.SetMessage("warning", this._i18n.registrationFullMessage, false);
                this.EnableSubmitButtons();
                return _context9.abrupt("return", false);

              case 77:
                this.SetMessage("warning", this._i18n.validationFailedMessage, false);
                this.EnableSubmitButtons();
                return _context9.abrupt("return", false);

              case 82:
                _context9.prev = 82;
                _context9.t0 = _context9["catch"](1);
                this.SetMessage("danger", this._i18n.registrationSaveErrorMessage, false);
                this.EnableSubmitButtons();
                return _context9.abrupt("return", false);

              case 87:
                return _context9.abrupt("return", true);

              case 88:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 82]]);
      }));

      function SubmitForm(_x3) {
        return _SubmitForm.apply(this, arguments);
      }

      return SubmitForm;
    }()
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this3 = this;

      var _self = this;

      this.shadowRoot.addEventListener("click", /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(e) {
          var target, _participant$firstNam, _participant$lastName, _participant$email, _participant$phone, _participant$addressL, _participant$addressL2, _participant$city, _participant$state, _participant$zip, _participant$formResp, selectedEventParticipantId, options, result, currentRowButton, contentRow, participant, _participant$firstNam2, _participant$lastName2, _participant$email2, _participant$phone2, formOptions, targetRemove, _selectedEventParticipantId;

          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  target = e.target.closest(".mppw-event-participant-button");

                  if (!target) {
                    _context10.next = 59;
                    break;
                  }

                  _self._$checkoutButton.style.display = "none";

                  _self.ShowUserInfoForms();

                  _self.ShowEventRegistrationDataForms();

                  selectedEventParticipantId = +target.getAttribute("eventParticipantId");
                  options = {
                    action: "save",
                    fromEdit: true
                  };

                  if (!_self._form._isDirty) {
                    _context10.next = 18;
                    break;
                  }

                  _self.ShowSpinner();

                  _context10.next = 11;
                  return _self.SubmitForm(options);

                case 11:
                  result = _context10.sent;

                  if (result) {
                    _context10.next = 15;
                    break;
                  }

                  _self.HideSpinner();

                  return _context10.abrupt("return");

                case 15:
                  _context10.next = 17;
                  return _self.UpdateEventParticipants(selectedEventParticipantId);

                case 17:
                  _self.HideSpinner();

                case 18:
                  target.style.display = "none";

                  if (_self.currentEventParticipantId) {
                    _self.currentEditRow = _self.shadowRoot.querySelector("[data-event-participant-id=\"".concat(_self.currentEventParticipantId, "\"]"));
                    currentRowButton = _self.currentEditRow.querySelector(".mppw-event-participant-button");
                    currentRowButton.style.display = "";
                    _self.currentEditRow.style.fontWeight = "normal";
                  }

                  _self._$registerAndCheckoutButton.style.display = "none";
                  _self._$registerAndAddAnotherButton.style.display = "none";
                  _self._$saveAndCheckoutButton.style.display = "";
                  _self._$saveAndAddAnotherButton.style.display = "";
                  _self._$showAnotherPersonFormButton.style.display = "none";
                  contentRow = target.closest(".mppw-event-participant-content-row");

                  if (contentRow) {
                    _context10.next = 28;
                    break;
                  }

                  return _context10.abrupt("return");

                case 28:
                  contentRow.style.fontWeight = "bold"; //_self.currentEditRow = contentRow;

                  _self.currentEventParticipantId = selectedEventParticipantId; // Reset address and contact form

                  _self.ResetAddressForm();

                  _self.ResetContactInfoForm(); // Clear promocodes if any


                  _self._$promoCodeTable.innerHTML = "";
                  _self._$promoCodeTable.style.display = "none";
                  _self._$registerAsContainer.style.display = "none";
                  _self._$updateMyInfoContainer.style.display = "none";
                  _self._$userHasRegisteredContainer.style.display = "none";
                  participant = _self._eventParticipants.find(function (x) {
                    return x.eventParticipantId === selectedEventParticipantId;
                  });

                  if (_self._userInfo != null) {
                    _self._$registerAs.value = participant.contactId;
                  }

                  _self._$firstNameText.value = (_participant$firstNam = participant.firstName) !== null && _participant$firstNam !== void 0 ? _participant$firstNam : "";
                  _self._$lastNameText.value = (_participant$lastName = participant.lastName) !== null && _participant$lastName !== void 0 ? _participant$lastName : "";
                  _self._$firstNameText.disabled = true;
                  _self._$lastNameText.disabled = true;
                  _self._$emailText.value = (_participant$email = participant.email) !== null && _participant$email !== void 0 ? _participant$email : "";
                  _self._$phoneText.value = (_participant$phone = participant.phone) !== null && _participant$phone !== void 0 ? _participant$phone : "";
                  _self._$addressLine1.value = (_participant$addressL = participant.addressLine1) !== null && _participant$addressL !== void 0 ? _participant$addressL : "";
                  _self._$addressLine2.value = (_participant$addressL2 = participant.addressLine2) !== null && _participant$addressL2 !== void 0 ? _participant$addressL2 : "";
                  _self._$city.value = (_participant$city = participant.city) !== null && _participant$city !== void 0 ? _participant$city : "";
                  _self._$stateRegion.value = (_participant$state = participant.state) !== null && _participant$state !== void 0 ? _participant$state : "";
                  _self._$postalCode.value = (_participant$zip = participant.zip) !== null && _participant$zip !== void 0 ? _participant$zip : "";

                  if (participant.isMinorRegistration) {
                    _self._$attendeeFirstNameText.value = participant.minorFirstName;
                    _self._$attendeeLastNameText.value = participant.minorLastName;
                    _self._$attendeeDateOfBirth.value = participant.minorDateOfBirth.slice(0, 10) || "";
                    _self._$attendeeFirstNameText.disabled = true;
                    _self._$attendeeLastNameText.disabled = true;
                    _self._$parentFirstNameText.disabled = true;
                    _self._$parentLastNameText.disabled = true;
                    _self._$parentFirstNameText.value = (_participant$firstNam2 = participant.firstName) !== null && _participant$firstNam2 !== void 0 ? _participant$firstNam2 : "";
                    _self._$parentLastNameText.value = (_participant$lastName2 = participant.lastName) !== null && _participant$lastName2 !== void 0 ? _participant$lastName2 : "";
                    _self._$parentEmailText.value = (_participant$email2 = participant.email) !== null && _participant$email2 !== void 0 ? _participant$email2 : "";
                    _self._$parentPhoneText.value = (_participant$phone2 = participant.phone) !== null && _participant$phone2 !== void 0 ? _participant$phone2 : "";
                  }

                  _self._$eventParticipantId.value = selectedEventParticipantId;

                  if (((_participant$formResp = participant.formResponses) === null || _participant$formResp === void 0 ? void 0 : _participant$formResp.length) > 0) {
                    _self._$formResponseId.value = participant.formResponses[0].Form_Response_ID;
                  }

                  _self._productData.optionGroups.forEach(function (group) {
                    var groupId = group.optionGroupId;
                    var isRadio = group.mutuallyExclusive;
                    var isRequired = group.required;

                    if (isRadio && isRequired) {
                      var radioGroupElements = _self.shadowRoot.querySelectorAll("input[name=\"product-radio_".concat(groupId, "\"]"));

                      for (var i = 0; i < radioGroupElements.length; i++) {
                        radioGroupElements[i].checked = false;
                      }
                    }

                    group.optionPrices.forEach(function (option) {
                      if (option.isHidden) {
                        return;
                      }

                      var optionPriceElement = _self.shadowRoot.querySelector("#product-checkbox_".concat(groupId, "_").concat(option.optionPriceId));

                      if (!optionPriceElement) {
                        optionPriceElement = _self.shadowRoot.querySelector("#product-radio_".concat(option.optionPriceId));
                      }

                      if (!optionPriceElement) {
                        return;
                      }

                      var optionPriceInvoiceDetailElement = _self.shadowRoot.querySelector("#product-option-invoice-detail_".concat(groupId, "_").concat(option.optionPriceId));

                      if (!optionPriceInvoiceDetailElement) {
                        return;
                      }

                      var selectedOption = participant.selectedProductOptions.find(function (x) {
                        return x.productOptionId === option.optionPriceId;
                      });

                      if (selectedOption) {
                        if (selectedOption.invoiceDetailId) {
                          optionPriceInvoiceDetailElement.value = selectedOption.invoiceDetailId;
                        }

                        var elementType = optionPriceElement.getAttribute("type");

                        if (elementType === "checkbox") {
                          _self.EnableOptionRowElement(optionPriceElement);

                          optionPriceElement.checked = true;
                        } else if (elementType === "radio") {
                          _self.EnableOptionRowElement(optionPriceElement);

                          optionPriceElement.click();
                        }
                      } else {
                        if (optionPriceElement.type === "checkbox") {
                          optionPriceElement.checked = false;
                        }
                      }
                    }); // Promocodes

                    participant.selectedProductOptions.filter(function (x) {
                      return x.isPromoCode;
                    }).forEach(function (option) {
                      _self._$promoCodeText.value = option.promoCode;

                      _self.AddPromocode(option.promoCode, false);

                      _self._$promoCodeTable.style.display = "";
                    }); // Event Details

                    participant.selectedProductOptions.filter(function (x) {
                      return !x.productOptionId;
                    }).forEach(function (option) {
                      var productInvoiceDetailElement = _self.shadowRoot.querySelector("#product-invoice-detail_".concat(option.productId));

                      if (productInvoiceDetailElement && option.invoiceDetailId) {
                        productInvoiceDetailElement.value = option.invoiceDetailId;
                      }
                    });
                  }); // Clear checkboxes


                  formOptions = _self.shadowRoot.querySelectorAll("input[name^='mp_customform_']");
                  formOptions.forEach(function (option) {
                    if (option.type === "checkbox" && option.checked) {
                      option.click();
                      option.checked = false;
                    }
                  });
                  participant.formResponses.forEach(function (response) {
                    var formResponseElement = _self.shadowRoot.querySelector("#mp_customform_".concat(response.Form_Field_ID));

                    var formOptions = _self.shadowRoot.querySelectorAll("input[name='mp_customform_".concat(response.Form_Field_ID, "']"));

                    formOptions.forEach(function (formOption) {
                      if (formOption.value === response.Response && !formOption.checked) {
                        formOption.click();
                      }
                    });
                    formResponseElement.value = response.Response;
                  });

                  _self.UpdateTotal();

                  _self._form.SetIsDirty(false);

                case 59:
                  targetRemove = e.target.closest(".mppw-event-participant-remove-button");

                  if (!targetRemove) {
                    _context10.next = 65;
                    break;
                  }

                  _selectedEventParticipantId = +targetRemove.getAttribute("eventParticipantId");

                  if (_selectedEventParticipantId) {
                    _context10.next = 64;
                    break;
                  }

                  return _context10.abrupt("return");

                case 64:
                  _self.RemoveEventParticipant(_selectedEventParticipantId);

                case 65:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }());

      this._root.addEventListener("change", function (e) {
        var checkbox = e.target.closest(".product-checkbox");

        if (checkbox) {
          // Extract the group ID and option ID from the checkbox's name attribute
          var _checkbox$name$split = checkbox.name.split("_"),
              _checkbox$name$split2 = _slicedToArray(_checkbox$name$split, 3),
              _ = _checkbox$name$split2[0],
              optionGroupId = _checkbox$name$split2[1],
              optionPriceId = _checkbox$name$split2[2]; // Validate existence within the current product options


          var group = _self._productData.optionGroups.find(function (g) {
            return g.optionGroupId.toString() === optionGroupId;
          });

          var option = group && group.optionPrices.find(function (op) {
            return op.optionPriceId.toString() === optionPriceId;
          });

          if (group && option) {
            // Find and update the corresponding select element
            var selectElement = _self._root.querySelector("#product-qty_".concat(optionGroupId, "_").concat(optionPriceId));

            if (selectElement) {
              selectElement.disabled = !checkbox.checked;

              _self.UpdateTotal();
            }
          }
        }
      });

      this._$loginButton.addEventListener("click", function () {
        OAuthService.SignIn();
      });

      this._$showAnotherPersonFormButton.addEventListener("click", function (event) {
        event.preventDefault();

        _this3.ShowEventRegistrationDataForms();

        _this3.ShowUserInfoForms();

        if (_this3._userInfo) {
          _this3._$registerAsContainer.style.display = "";
        }

        _this3._$showAnotherPersonFormButton.style.display = "none";
        _this3._$addAnotherButton.style.display = "";
      });

      this._$checkoutButton.addEventListener("click", function (event) {
        event.preventDefault(); //Redirect to checkout widget

        var checkoutWidgetUrl = UrlUtils.AddQueryStringParams(_this3.checkouturl, _defineProperty({}, _this3._invoiceDetailWidgetIdParameterName, _this3._$invoiceId.value));
        window.location.href = checkoutWidgetUrl;
      });

      this._$registerAndAddAnotherButton.addEventListener("click", function (event) {
        event.preventDefault();
        var options = {
          action: "registerAndAddAnother"
        };

        _this3.SubmitForm(options);
      });

      this._$registerAndCheckoutButton.addEventListener("click", function (event) {
        event.preventDefault();
        var options = {
          action: "registerAndCheckout"
        };

        _this3.SubmitForm(options);
      });

      this._$saveAndAddAnotherButton.addEventListener("click", function (event) {
        event.preventDefault();
        var options = {
          action: "saveAndAddAnother"
        };

        _this3.SubmitForm(options);
      });

      this._$saveAndCheckoutButton.addEventListener("click", function (event) {
        event.preventDefault();
        var options = {
          action: "saveAndCheckout"
        };

        _this3.SubmitForm(options);
      });

      this._$addPromoCodeButton.addEventListener("click", function (event) {
        event.preventDefault();

        if (!!_this3._$promoCodeText.value) {
          _this3._$invalidPromoCode.style.display = "none";

          _this3.AddPromocode(_this3._$promoCodeText.value, true);
        }
      });

      this._$registerAs.addEventListener("change", function (e) {
        //Only show blank form if drop down value is null
        if (!!_this3._$registerAs.value) {
          _this3._form.SetIsDirty(false);

          _this3._$checkoutButton.style.display = "none";
          _this3._$showAnotherPersonFormButton.style.display = "none";

          _this3.ShowUserInfoForms();

          _this3.ShowEventRegistrationDataForms();

          if (_this3._$registerAs.value === "Blank Form") {
            _this3.HideUpdateMyInfoContainer();

            _this3._$addAnotherButton.style.display = "";

            _this3.ResetForm();
          } else {
            _this3.FillContactInfoForm(_this3._$registerAs.value);

            _this3.FillAddressForm(); // Check if user has already registered


            _this3.HasUserRegistered(e.target.value);

            _this3._$addAnotherButton.style.display = "";
          }
        } else {
          _this3.HideUserInfoForms();

          _this3.HideEventRegistrationDataForms();

          _this3._$registerAndCheckoutButton.style.display = "none";
          _this3._$showAnotherPersonFormButton.style.display = "none";
          _this3._$addAnotherButton.style.display = "none";
        }
      });
    }
  }, {
    key: "AddPromocode",
    value: function AddPromocode(promoCodeText) {
      var _this4 = this;

      var needToValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var productService = new ProductsApiService();
      this._$invalidPromoCode.style.display = "none";
      var promoCode = promoCodeText;
      var productId = this._eventData.registrationProductId; // For already applied promocodes only to avoid conflicts with Qty On Hand

      productService.ValidPromoCode(productId, promoCode, needToValidate).then(function (result) {
        var alreadyHasExclusiveGroupPromo = !!_this4._$promoCodeTable.querySelector("input[data-exclusivegroupid=\"".concat(result.mutuallyExclusiveOptionGroupId, "\"]"));
        var promoCodeWithinDaysOutToHide = false;
        _this4._daysOutToHide = 0;

        if (result.daysOutToHide !== null && result.daysOutToHide > 0 && _this4._eventStartDate !== null && _this4._eventStartDate !== "") {
          _this4._daysOutToHide = result.daysOutToHide;
          var currentDate = new Date(),
              evtStartDate = new Date(_this4._eventStartDate);
          var diffTime = Math.abs(currentDate - evtStartDate),
              diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          if (diffDays < result.daysOutToHide) {
            promoCodeWithinDaysOutToHide = true;
          }
        }

        if (!!result.isValidPromoCode && result.promoCodePrice != 0 && !alreadyHasExclusiveGroupPromo && !promoCodeWithinDaysOutToHide) {
          ProductFormBuilder.BuildPromoCodeRow(_this4._$promoCodeTable, promoCode, result.promoCodePrice, result.mutuallyExclusiveOptionGroupId, _this4);
          _this4._$promoCodeText.value = "";

          _this4.HideMessage();

          _this4.UpdateTotal();

          if (_this4._$promoCodeTable.rows.length >= 1) {
            // Show promo codes table
            _this4._$promoCodeTable.style.display = "";
          }
        } else {
          _this4._$invalidPromoCode.style.display = "";
        }
      });
    }
  }, {
    key: "BindProductEventListeners",
    value: function BindProductEventListeners() {
      var _this5 = this;

      this._$productRadios = this._root.querySelectorAll(".product-radio");
      this._$productCheckboxes = this._root.querySelectorAll(".product-checkbox");
      this._$productSelects = this._root.querySelectorAll(".product-select");

      this._$productRadios.forEach(function (el) {
        if (!el.getAttribute("data-listener")) {
          el.addEventListener("click", function (event) {
            _this5.UpdateTotal();
          });
          el.setAttribute("data-listener", true);
        }
      });

      this._$productCheckboxes.forEach(function (el) {
        return el.addEventListener("click", function (event) {
          _this5.UpdateTotal();
        });
      });

      this._$productSelects.forEach(function (el) {
        return el.addEventListener("change", function (event) {
          _this5.UpdateTotal();
        });
      });
    }
  }, {
    key: "HasUserRegistered",
    value: function HasUserRegistered(contactId) {
      var _this6 = this;

      var eventApiService = new EventsApiService();

      if (!!contactId) {
        eventApiService.HasRegistered(this._eventData.eventId, contactId).then(function (registeredResponse) {
          if (registeredResponse) {
            _this6._$userHasRegisteredContainer.style.display = "";
          } else {
            _this6._$userHasRegisteredContainer.style.display = "none";
          }
        })["catch"](function (error) {
          _this6._$userHasRegisteredContainer.style.display = "none";
        });
      } else {
        this._$userHasRegisteredContainer.style.display = "none";
      }
    }
  }, {
    key: "UpdateTotal",
    value: function UpdateTotal() {
      var selectedEventParticipantId = this.GetSelectedEventParticipantId();
      this._registrationTotal = ProductFormBuilder.CalculateTotal(this._$registrationForm, this._productData, this._eventParticipants, selectedEventParticipantId);

      this._HandleRegistrationTotal();
    }
  }, {
    key: "UpdateParticipantTotal",
    value: function UpdateParticipantTotal() {
      var participantsTotal = ProductFormBuilder.CalculateParticipantsTotal(this._eventParticipants);
      this._registrationTotal = parseFloat(participantsTotal);

      this._HandleRegistrationTotal();
    }
  }, {
    key: "_HandleRegistrationTotal",
    value: function _HandleRegistrationTotal() {
      if (this._registrationTotal < 0) {
        if (this._$promoCodeTable.rows.length <= 0) {
          this.DisableSubmitButtons();
          this.SetMessage("danger", this._i18n.registrationTotalInvalidMessage, false);
        } else {
          this._registrationTotal = 0;

          this._UpdateRegistrationTotalDisplay();
        }
      } else {
        this._UpdateRegistrationTotalDisplay();
      }
    }
  }, {
    key: "_UpdateRegistrationTotalDisplay",
    value: function _UpdateRegistrationTotalDisplay() {
      var _this$_eventData4;

      if ((_this$_eventData4 = this._eventData) !== null && _this$_eventData4 !== void 0 && _this$_eventData4.isFreeEvent) {
        this._$addressLine1.removeAttribute("required");

        this._$city.removeAttribute("required");

        this._$stateRegion.removeAttribute("required");

        this._$postalCode.removeAttribute("required");

        this._$registrationTotalContainer.style.display = "none";
      } else {
        this._$registrationTotalContainer.style.display = "block";
        this._$registrationTotalValue.innerHTML = NumberUtils.toCurrencyString(this._registrationTotal);
        this.EnableSubmitButtons();
        this.HideMessage();
      }
    }
  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$spinner = this._root.querySelector("#spinner");
      this._$componentMessageContainer = this._root.querySelector("#componentMessageContainer");
      this._$componentMessageText = this._root.querySelector("#componentMessageText");
      this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
      this._$loginButton = this._root.querySelector("#loginButton");
      this._$eventId = this._root.querySelector("#EventId");
      this._$householdId = this._root.querySelector("#HouseholdId");
      this._$eventParticipantId = this._root.querySelector("#EventParticipantId");
      this._$formResponseId = this._root.querySelector("#FormResponseId");
      this._$productId = this._root.querySelector("#ProductId");
      this._$isMinorRegistration = this._root.querySelector("#IsMinorRegistration");
      this._$currentUserContactId = this._root.querySelector("#CurrentUserContactId");
      this._$priceContainer = this._root.querySelector("#priceContainer");
      this._$registrationPriceLabel = this._root.querySelector("#registrationPriceLabel");
      this._$singlePriceContainer = this._root.querySelector("#singlePriceContainer");
      this._$singlePriceValue = this._root.querySelector("#singlePriceValue");
      this._$depositPriceContainer = this._root.querySelector("#depositPriceContainer");
      this._$depositPriceText = this._root.querySelector("#depositPriceText");
      this._$depositPriceValue = this._root.querySelector("#depositPriceValue");
      this._$invoiceId = this._root.querySelector("#InvoiceId");
      this._$detailsContainer = this._root.querySelector("#detailsContainer");
      this._$map = this._root.querySelector("#map");
      this._$mapAddress = this._root.querySelector("#mapAddress");
      this._$mapContainer = this._root.querySelector("#mapContainer");
      this._$registrationForm = this._root.querySelector("#registrationForm");
      this._$registrationTotalValue = this._root.querySelector("#registrationTotalValue");
      this._$productOptionsWrapper = this._root.querySelector("#productOptionsWrapper");
      this._$productOptionsTitle = this._root.querySelector("#productOptionsTitle");
      this._$productOptionsContainer = this._root.querySelector("#productOptionsContainer");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$registrationNotActiveContainer = this._root.querySelector("#registrationNotActiveMessageContainer");
      this._$registrationNotActiveMessageText = this._root.querySelector("#registrationNotActiveMessageText");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$promoCodeText = this._root.querySelector("#promoCodeText");
      this._$addPromoCodeButton = this._root.querySelector("#addPromoCodeButton");
      this._$promoCodeContainer = this._root.querySelector("#promoCodeContainer");
      this._$promoCodeTable = this._root.querySelector("#promoCodeTable");
      this._$invalidPromoCode = this._root.querySelector("#invalidPromoCode");
      this._$registerAndAddAnotherButton = this._root.querySelector("#addAnotherButton");
      this._$registerAndCheckoutButton = this._root.querySelector("#registerAndCheckoutButton");
      this._$saveAndAddAnotherButton = this._root.querySelector("#saveAndAddAnotherButton");
      this._$saveAndCheckoutButton = this._root.querySelector("#saveAndCheckoutButton");
      this._$showAnotherPersonFormButton = this._root.querySelector("#showAnotherPersonFormButton");
      this._$addAnotherButton = this._root.querySelector("#addAnotherButton");
      this._$checkoutButton = this._root.querySelector("#checkoutButton");
      this._$contactInfoForm = this._root.querySelector("#contactInfoForm");
      this._$attendeeInfoForm = this._root.querySelector("#attendeeInfoForm");
      this._$parentInfoForm = this._root.querySelector("#parentInfoForm");
      this._$registerAsContainer = this._root.querySelector("#registerAsContainer");
      this._$registerAs = this._root.querySelector("#registerAs");
      this._$firstNameText = this._root.querySelector("#firstName");
      this._$lastNameText = this._root.querySelector("#lastName");
      this._$emailText = this._root.querySelector("#emailAddress");
      this._$phoneText = this._root.querySelector("#mobilePhone");
      this._$attendeeFirstNameText = this._root.querySelector("#attendeeFirstName");
      this._$attendeeLastNameText = this._root.querySelector("#attendeeLastName");
      this._$attendeeDateOfBirth = this._root.querySelector("#attendeeDateOfBirth");
      this._$parentFirstNameText = this._root.querySelector("#parentFirstName");
      this._$parentLastNameText = this._root.querySelector("#parentLastName");
      this._$parentEmailText = this._root.querySelector("#parentEmailAddress");
      this._$parentPhoneText = this._root.querySelector("#parentMobilePhone");
      this._$addressFormWrapper = this._root.querySelector("#addressFormWrapper");
      this._$addressLine1 = this._root.querySelector("#addressLine1");
      this._$addressLine1Label = this._root.querySelector("#addressLine1Label");
      this._$addressLine2 = this._root.querySelector("#addressLine2");
      this._$city = this._root.querySelector("#city");
      this._$cityLabel = this._root.querySelector("#cityLabel");
      this._$stateRegion = this._root.querySelector("#stateRegion");
      this._$stateRegionLabel = this._root.querySelector("#stateLabel");
      this._$postalCode = this._root.querySelector("#postalCode");
      this._$postalCodeLabel = this._root.querySelector("#zipCodeLabel");
      this._$eventParticipantsContainer = this._root.querySelector("#eventParticipantsContainer");
      this._$userHasRegisteredContainer = this._root.querySelector("#userHasRegisteredContainer");
      this._$productDescription = this._root.querySelector(".mppw-product-description");
      this._$updateMyInfoContainer = this._root.querySelector("#updateMyInfoContainer");
      this._$updateMyInfo = this._root.querySelector("#inquire_updateMyInfo"); //Note: This name is required since there is a dependency inside CustomFormBuilder.js

      this._$formFields = this._root.querySelector("#formFields");
      this._$updateInformationWarningMessage = this._root.querySelector("#updateInformationWarningMessage");
      this._$registrationTotalContainer = this._root.querySelector("#registrationTotalContainer");
    }
  }, {
    key: "LoadAttributes",
    value: function LoadAttributes() {
      this.checkouturl = this.getAttribute("checkouturl");
      this.returnUrl = this.getAttribute("returnurl");
      this.opportunityFinderWidgetUrl = this.getAttribute("opportunityfinderwidgettargeturl");
    }
  }, {
    key: "LoadEventData",
    value: function () {
      var _LoadEventData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _eventId;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _eventId = CommonBuilder.GetId(this._eventDetailWidgetIdParameterName);

                if (!_eventId) {
                  _eventId = CommonBuilder.GetId("id");
                }

                this.invoiceId = CommonBuilder.GetInvoiceId();
                this._$eventId.value = _eventId;
                return _context11.abrupt("return", this._eventService.GetEventDetail(_eventId));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function LoadEventData() {
        return _LoadEventData.apply(this, arguments);
      }

      return LoadEventData;
    }()
  }, {
    key: "LoadLabels",
    value: function () {
      var _LoadLabels = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this7 = this;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", new I18N(MppEventDetails.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this7._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this7._root.innerHTML = "".concat(error);
                  }
                }));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function LoadLabels() {
        return _LoadLabels.apply(this, arguments);
      }

      return LoadLabels;
    }()
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      var _this8 = this;

      var autoHideMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this._$registrationForm.style.display === "none") {
        this.SetComponentMessage(status, message, autoHideMessage);
        return;
      }

      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";

      if (autoHideMessage) {
        setTimeout(function () {
          _this8.HideMessage();
        }, 3000);
      }
    }
  }, {
    key: "SetComponentMessage",
    value: function SetComponentMessage(status, message) {
      var _this9 = this;

      var autoHideMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this._$componentMessageContainer.classList.remove("mppw-alert__success");

      this._$componentMessageContainer.classList.remove("mppw-alert__info");

      this._$componentMessageContainer.classList.remove("mppw-alert__warning");

      this._$componentMessageContainer.classList.remove("mppw-alert__danger");

      this._$componentMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$componentMessageText.innerHTML = message;
      this._$componentMessageContainer.style.display = "";

      if (autoHideMessage) {
        setTimeout(function () {
          _this9.HideComponentMessage();
        }, 3000);
      }
    }
  }, {
    key: "HideComponentMessage",
    value: function HideComponentMessage() {
      this._$componentMessageText.innerHTML = "";
      this._$componentMessageContainer.style.display = "none";
    }
  }, {
    key: "SetRegistrationNotActiveMessage",
    value: function SetRegistrationNotActiveMessage() {
      this._$registrationNotActiveContainer.classList.add("mppw-alert__warning");

      this._$registrationNotActiveMessageText.innerHTML = this._i18n.registrationNotActiveMessage;
      this._$registrationNotActiveContainer.style.display = "";
    }
  }, {
    key: "HideMessage",
    value: function HideMessage() {
      this._$resultMessageText.innerHTML = "";
      this._$resultMessageContainer.style.display = "none";
    }
  }, {
    key: "ShowSpinner",
    value: function ShowSpinner() {
      this._$spinner.style.display = "";
    }
  }, {
    key: "HideSpinner",
    value: function HideSpinner() {
      this._$spinner.style.display = "none";
    }
  }, {
    key: "FillContactInfoForm",
    value: function FillContactInfoForm(contactId) {
      var _this10 = this;

      if (contactId) {
        var member = this._members.find(function (x) {
          return x.contactId == _this10._$registerAs.value;
        });

        if (member) {
          if (this._isMinorRegistration) {
            var _member$firstName, _member$lastName, _this$_userContactInf, _this$_userContactInf2, _this$_userContactInf3, _this$_userContactInf4, _this$_userContactInf5, _this$_userContactInf6, _this$_userContactInf7, _this$_userContactInf8;

            this._$attendeeFirstNameText.value = (_member$firstName = member.firstName) !== null && _member$firstName !== void 0 ? _member$firstName : "";
            this._$attendeeLastNameText.value = (_member$lastName = member.lastName) !== null && _member$lastName !== void 0 ? _member$lastName : "";
            this._$attendeeDateOfBirth.value = member.dateOfBirth && member.dateOfBirth.slice(0, 10) || "";
            this._$attendeeFirstNameText.disabled = true;
            this._$attendeeLastNameText.disabled = true;
            this._$parentFirstNameText.value = (_this$_userContactInf = (_this$_userContactInf2 = this._userContactInfo) === null || _this$_userContactInf2 === void 0 ? void 0 : _this$_userContactInf2.firstName) !== null && _this$_userContactInf !== void 0 ? _this$_userContactInf : "";
            this._$parentLastNameText.value = (_this$_userContactInf3 = (_this$_userContactInf4 = this._userContactInfo) === null || _this$_userContactInf4 === void 0 ? void 0 : _this$_userContactInf4.lastName) !== null && _this$_userContactInf3 !== void 0 ? _this$_userContactInf3 : "";
            this._$parentEmailText.value = (_this$_userContactInf5 = (_this$_userContactInf6 = this._userContactInfo) === null || _this$_userContactInf6 === void 0 ? void 0 : _this$_userContactInf6.emailAddress) !== null && _this$_userContactInf5 !== void 0 ? _this$_userContactInf5 : "";
            this._$parentPhoneText.value = (_this$_userContactInf7 = (_this$_userContactInf8 = this._userContactInfo) === null || _this$_userContactInf8 === void 0 ? void 0 : _this$_userContactInf8.mobilePhoneNumber) !== null && _this$_userContactInf7 !== void 0 ? _this$_userContactInf7 : "";
            this._$parentFirstNameText.disabled = true;
            this._$parentLastNameText.disabled = true;
          } else {
            var _member$firstName2, _member$lastName2, _member$emailAddress, _member$mobilePhoneNu;

            this._$firstNameText.value = (_member$firstName2 = member.firstName) !== null && _member$firstName2 !== void 0 ? _member$firstName2 : "";
            this._$lastNameText.value = (_member$lastName2 = member.lastName) !== null && _member$lastName2 !== void 0 ? _member$lastName2 : "";
            this._$emailText.value = (_member$emailAddress = member.emailAddress) !== null && _member$emailAddress !== void 0 ? _member$emailAddress : "";
            this._$phoneText.value = (_member$mobilePhoneNu = member.mobilePhoneNumber) !== null && _member$mobilePhoneNu !== void 0 ? _member$mobilePhoneNu : "";
            this._$firstNameText.disabled = true;
            this._$lastNameText.disabled = true;
          }

          this._$updateMyInfo.checked = false;
        } else {
          this.ResetContactInfoForm();
        }
      } else {
        this.ResetContactInfoForm();
      }

      this.UpdateNameFieldsState();
    }
  }, {
    key: "FillAddressForm",
    value: function FillAddressForm() {
      if (this._household) {
        var _this$_household$addr, _this$_household, _this$_household$addr2, _this$_household$addr3, _this$_household2, _this$_household2$add, _this$_household$addr4, _this$_household3, _this$_household3$add, _this$_household$addr5, _this$_household4, _this$_household4$add, _this$_household$addr6, _this$_household5, _this$_household5$add;

        this._$addressLine1.value = (_this$_household$addr = (_this$_household = this._household) === null || _this$_household === void 0 ? void 0 : (_this$_household$addr2 = _this$_household.address) === null || _this$_household$addr2 === void 0 ? void 0 : _this$_household$addr2.addressLine1) !== null && _this$_household$addr !== void 0 ? _this$_household$addr : "";
        this._$addressLine2.value = (_this$_household$addr3 = (_this$_household2 = this._household) === null || _this$_household2 === void 0 ? void 0 : (_this$_household2$add = _this$_household2.address) === null || _this$_household2$add === void 0 ? void 0 : _this$_household2$add.addressLine2) !== null && _this$_household$addr3 !== void 0 ? _this$_household$addr3 : "";
        this._$city.value = (_this$_household$addr4 = (_this$_household3 = this._household) === null || _this$_household3 === void 0 ? void 0 : (_this$_household3$add = _this$_household3.address) === null || _this$_household3$add === void 0 ? void 0 : _this$_household3$add.city) !== null && _this$_household$addr4 !== void 0 ? _this$_household$addr4 : "";
        this._$stateRegion.value = (_this$_household$addr5 = (_this$_household4 = this._household) === null || _this$_household4 === void 0 ? void 0 : (_this$_household4$add = _this$_household4.address) === null || _this$_household4$add === void 0 ? void 0 : _this$_household4$add.stateRegion) !== null && _this$_household$addr5 !== void 0 ? _this$_household$addr5 : "";
        this._$postalCode.value = (_this$_household$addr6 = (_this$_household5 = this._household) === null || _this$_household5 === void 0 ? void 0 : (_this$_household5$add = _this$_household5.address) === null || _this$_household5$add === void 0 ? void 0 : _this$_household5$add.postalCode) !== null && _this$_household$addr6 !== void 0 ? _this$_household$addr6 : "";
      } else {
        this.ResetAddressForm();
      }
    }
  }, {
    key: "ResetContactInfoForm",
    value: function ResetContactInfoForm() {
      this._$firstNameText.value = "";
      this._$lastNameText.value = "";
      this._$emailText.value = "";
      this._$phoneText.value = "";
      this._$attendeeFirstNameText.value = "";
      this._$attendeeLastNameText.value = "";
      this._$attendeeDateOfBirth.value = "";
      this._$parentFirstNameText.value = "";
      this._$parentLastNameText.value = "";
      this._$parentEmailText.value = "";
      this._$parentPhoneText.value = "";
      this._$updateMyInfo.checked = false; // Enable all name fields when resetting

      this._$firstNameText.disabled = false;
      this._$lastNameText.disabled = false;
      this._$attendeeFirstNameText.disabled = false;
      this._$attendeeLastNameText.disabled = false;
      this._$parentFirstNameText.disabled = false;
      this._$parentLastNameText.disabled = false;
    }
  }, {
    key: "ResetAddressForm",
    value: function ResetAddressForm() {
      this._$addressLine1.value = "";
      this._$addressLine2.value = "";
      this._$city.value = "";
      this._$stateRegion.value = "";
      this._$postalCode.value = "";
    }
  }, {
    key: "DisableSubmitButtons",
    value: function DisableSubmitButtons() {
      this._$registerAndCheckoutButton.disabled = true;
      this._$registerAndAddAnotherButton.disabled = true;
      this._$saveAndCheckoutButton.disabled = true;
      this._$saveAndAddAnotherButton.disabled = true;
      var editButtons = this.shadowRoot.querySelectorAll(".mppw-event-participant-button");
      editButtons.forEach(function (button) {
        button.style.pointerEvents = "none";
        button.style.color = "#bbbbbb";
        button.style.cursor = "default";
      });
    }
  }, {
    key: "HideUserInfoForms",
    value: function HideUserInfoForms() {
      if (this._isMinorRegistration) {
        this._$attendeeInfoForm.style.display = "none";
        this._$parentInfoForm.style.display = "none";
      } else {
        this._$contactInfoForm.style.display = "none";
      }

      this._$addressFormWrapper.style.display = "none";
      this.HideUpdateMyInfoContainer();
    }
  }, {
    key: "ShowUserInfoForms",
    value: function ShowUserInfoForms() {
      if (this._isMinorRegistration) {
        this._$attendeeInfoForm.style.display = "";
        this._$parentInfoForm.style.display = "";

        this._$firstNameText.removeAttribute("required");

        this._$lastNameText.removeAttribute("required");

        this._$emailText.removeAttribute("required");

        this._$phoneText.removeAttribute("required");
      } else {
        this._$contactInfoForm.style.display = "";

        this._$attendeeFirstNameText.removeAttribute("required");

        this._$attendeeLastNameText.removeAttribute("required");

        this._$attendeeDateOfBirth.removeAttribute("required");

        this._$parentFirstNameText.removeAttribute("required");

        this._$parentLastNameText.removeAttribute("required");

        this._$parentEmailText.removeAttribute("required");

        this._$parentPhoneText.removeAttribute("required");
      }

      this._$addressFormWrapper.style.display = "";
      this.ShowUpdateMyInfoContainer();
    }
  }, {
    key: "ShowRegisterAsForm",
    value: function ShowRegisterAsForm() {
      if (this._userIsAuthenticated) {
        this._$registerAsContainer.style.display = "";
      }
    }
  }, {
    key: "HideEventRegistrationDataForms",
    value: function HideEventRegistrationDataForms() {
      this._$promoCodeContainer.style.display = "none";
      this._$registrationTotalContainer.style.display = "none";
      this._$productOptionsWrapper.style.display = "none";
      this._$formFields.style.display = "none";
      this._$priceContainer.style.display = "none";
    }
  }, {
    key: "ShowEventRegistrationDataForms",
    value: function ShowEventRegistrationDataForms() {
      var _this$_productData;

      if (!!((_this$_productData = this._productData) !== null && _this$_productData !== void 0 && _this$_productData.hasPromoCode)) {
        this._$promoCodeContainer.style.display = "";
      } // Check if there are any visible option prices


      var hasVisibleOptions = this._productData && this._productData.optionGroups.some(function (group) {
        return group.optionPrices.some(function (price) {
          return price.isHidden === false;
        });
      });

      if (hasVisibleOptions) {
        // Show the productOptionsWrapper if there are visible options
        this._$productOptionsWrapper.style.display = "";
      } else {
        // Hide the productOptionsWrapper if there are no visible options
        this._$productOptionsWrapper.style.display = "none";
      }

      this._$formFields.style.display = "";
      this._$priceContainer.style.display = "";
      this._$registerAndCheckoutButton.style.display = "";
      this._$checkoutButton.style.display = "none";
      this.UpdateTotal();
    }
  }, {
    key: "EnableSubmitButtons",
    value: function EnableSubmitButtons() {
      this._$registerAndCheckoutButton.disabled = false;
      this._$registerAndAddAnotherButton.disabled = false;
      this._$saveAndCheckoutButton.disabled = false;
      this._$saveAndAddAnotherButton.disabled = false;
      var editButtons = this.shadowRoot.querySelectorAll(".mppw-event-participant-button");
      editButtons.forEach(function (button) {
        button.style.pointerEvents = "";
        button.style.color = "";
        button.style.cursor = "";
      });
    }
  }, {
    key: "DrawExistingParticipants",
    value: function DrawExistingParticipants() {
      var _this11 = this;

      var selectedEventParticipant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      if (!this._eventParticipants || this._eventParticipants.length <= 0) return;
      this._$eventParticipantsContainer.innerHTML = "";
      var index = 1;

      this._eventParticipants.forEach(function (participant) {
        var _this11$_eventData;

        var participantContainer = document.createElement("div");
        participantContainer.className = "mppw-event-participant-container";
        var titleRow = document.createElement("div");
        titleRow.className = "mppw-event-participant-title-row";
        var participantIcon = document.createElement("div");
        participantIcon.className = "mppw-participant-icon mppw-icon-user-circle";
        titleRow.appendChild(participantIcon);
        var participantNumber = document.createElement("div");
        participantNumber.className = "mppw-participant-number";
        participantNumber.innerText = "Participant " + index;
        titleRow.appendChild(participantNumber);
        var contentRow = document.createElement("div");
        contentRow.className = "mppw-event-participant-content-row";
        contentRow.setAttribute("data-event-participant-id", participant.eventParticipantId);

        if (selectedEventParticipant && participant.eventParticipantId == selectedEventParticipant) {
          contentRow.style.fontWeight = "bold";
        }

        var participantName = document.createElement("div");
        participantName.className = "mppw-event-participant-name";
        participantName.innerText = "".concat(participant.firstName, " ").concat(participant.lastName);
        contentRow.appendChild(participantName);
        var participantContacts = document.createElement("div");
        participantContacts.className = "mppw-event-participant-contacts";
        participantContacts.innerHTML = "<div>".concat(participant.email, "</div><div>").concat(participant.phone, "</div>");
        contentRow.appendChild(participantContacts);
        var participantAddress = document.createElement("div");
        participantAddress.className = "mppw-event-participant-address";
        participantAddress.innerHTML = "<div>".concat(participant.addressLine1).concat(participant.addressLine2 ? "<br>".concat(participant.addressLine2) : "", "</div>\n                                        <div>").concat(participant.city, ", ").concat(participant.state, " ").concat(participant.zip, "</div>");
        contentRow.appendChild(participantAddress);
        var participantPrice = document.createElement("div");
        participantPrice.className = "mppw-event-participant-price";
        participantPrice.innerText = (_this11$_eventData = _this11._eventData) !== null && _this11$_eventData !== void 0 && _this11$_eventData.isFreeEvent ? "" : "".concat(NumberUtils.toCurrencyString(participant.lineTotal));
        contentRow.appendChild(participantPrice);

        if (participant.lineTotal <= 0) {
          var registeredDiv = document.createElement("div");
          registeredDiv.className = "mppw-registered-label";
          var boldText = document.createElement("div");
          boldText.style.fontWeight = "bold";
          boldText.innerText = _this11._i18n.registeredLabel;
          registeredDiv.appendChild(boldText);
          contentRow.appendChild(registeredDiv);
        } else {
          var buttonsContainer = document.createElement("div");
          buttonsContainer.className = "mppw-event-participant-buttons";
          var editButton = document.createElement("div");
          editButton.className = "mppw-btn primary mppw-event-participant-button";
          editButton.setAttribute("eventParticipantId", participant.eventParticipantId);
          editButton.innerText = "Edit";
          buttonsContainer.appendChild(editButton);
          var removeButton = document.createElement("div");
          removeButton.className = "mppw-btn secondary mppw-event-participant-remove-button";
          removeButton.setAttribute("eventParticipantId", participant.eventParticipantId);
          removeButton.innerText = "X";
          buttonsContainer.appendChild(removeButton);
          contentRow.appendChild(buttonsContainer);

          if (selectedEventParticipant && selectedEventParticipant == participant.eventParticipantId) {
            buttonsContainer.style.display = "none";
          }
        }

        participantContainer.appendChild(titleRow);
        participantContainer.appendChild(contentRow);

        if (participant.isMinorRegistration) {
          var _contentRow = document.createElement("div");

          _contentRow.className = "mppw-event-participant-content-row";
          _contentRow.style.fontSize = "13px";
          _contentRow.style.justifyContent = "flex-start";

          if (selectedEventParticipant && participant.eventParticipantId == selectedEventParticipant) {
            _contentRow.style.fontWeight = "bold";
          }

          var _participantName = document.createElement("div");

          _participantName.className = "mppw-event-participant-name";
          _participantName.innerText = "Minor Registration";
          _participantName.style.fontStyle = "italic";
          _participantName.style.width = "unset";

          _contentRow.appendChild(_participantName);

          var _participantContacts = document.createElement("div");

          _participantContacts.className = "mppw-event-participant-contacts";
          _participantContacts.innerHTML = "<div>".concat(participant.minorFirstName, " ").concat(participant.minorLastName, "</div><div>").concat(participant.minorDateOfBirth.slice(0, 10), "</div>");
          _participantContacts.style.fontWeight = "bold";

          _contentRow.appendChild(_participantContacts);

          participantContainer.appendChild(_contentRow);
        }

        _this11._$eventParticipantsContainer.appendChild(participantContainer);

        index += 1;
      });

      this.UpdateParticipantTotal();
    }
  }, {
    key: "CheckEventAndProductAvailability",
    value: function () {
      var _CheckEventAndProductAvailability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(formData) {
        var _this12 = this;

        var eventApiService, availabilityResponse, eventAvailabilityStatus, soldOutProducts, status, soldOutProductNames;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                eventApiService = new EventsApiService();
                _context13.next = 3;
                return eventApiService.CheckAvailability(formData);

              case 3:
                availabilityResponse = _context13.sent;
                eventAvailabilityStatus = {
                  available: 200,
                  soldOut: 409
                };

                if (availabilityResponse.isSuccessful) {
                  _context13.next = 11;
                  break;
                }

                soldOutProducts = availabilityResponse.soldOutProducts, status = availabilityResponse.status;

                if (soldOutProducts && soldOutProducts.length > 0) {
                  soldOutProductNames = soldOutProducts.map(function (product) {
                    return product.optionPrice.optionTitle;
                  });
                  this.SetMessage("warning", "Some products are sold out: ".concat(soldOutProductNames.join(", ")), false); // Disable row elements for sold-out products

                  soldOutProducts.forEach(function (product) {
                    var element = _this12.FindOptionRowElement(product.optionPrice.optionPriceId);

                    if (element) {
                      _this12.DisableOptionRowElement(element);
                    }
                  });
                }

                if (status === eventAvailabilityStatus.soldOut) {
                  this.SetMessage("warning", "The event is fully booked.", false);
                }

                this.EnableSubmitButtons();
                return _context13.abrupt("return", false);

              case 11:
                return _context13.abrupt("return", true);

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function CheckEventAndProductAvailability(_x5) {
        return _CheckEventAndProductAvailability.apply(this, arguments);
      }

      return CheckEventAndProductAvailability;
    }()
  }, {
    key: "GetSelectedEventParticipantId",
    value: function GetSelectedEventParticipantId() {
      var _this13 = this;

      if (this._eventParticipants && this._eventParticipants.length > 0) {
        var selectedParticipant = this._eventParticipants.find(function (participant) {
          return participant.eventParticipantId === _this13.currentEventParticipantId;
        });

        return selectedParticipant ? selectedParticipant.eventParticipantId : null;
      }

      return null;
    }
  }, {
    key: "EnableOptionRowElement",
    value: function EnableOptionRowElement(element) {
      if (!element.disabled) {
        return;
      }

      element.disabled = false;
      var row = element.closest("tr");
      row.classList.remove("mppw-event-gray-out");
      var label = element.parentElement;
      label.classList.remove("default-cursor");
      label.classList.add("pointer-cursor");
      var span = element.nextElementSibling;
      var elementType = element.type;

      if (elementType === "checkbox") {
        span.classList.remove("mppw-checkbox-gray-out");
        span.classList.add("mppw-checkbox");
      } else if (elementType === "radio") {
        span.classList.remove("mppw-radio-gray-out");
        span.classList.add("mppw-radio");
      }
    }
  }, {
    key: "DisableOptionRowElement",
    value: function DisableOptionRowElement(element) {
      if (element.disabled) {
        return;
      }

      element.disabled = true;
      var row = element.closest("tr");
      row.classList.add("mppw-event-gray-out");
      var label = element.parentElement;
      label.classList.remove("pointer-cursor");
      label.classList.add("default-cursor");
      var span = element.nextElementSibling;
      var elementType = element.type;

      if (elementType === "checkbox") {
        span.classList.remove("mppw-checkbox");
        span.classList.add("mppw-checkbox-gray-out");
      } else if (elementType === "radio") {
        span.classList.remove("mppw-radio");
        span.classList.add("mppw-radio-gray-out");
      }
    }
  }, {
    key: "FindOptionRowElement",
    value: function FindOptionRowElement(optionPriceId) {
      var element = this.shadowRoot.querySelector("#product-checkbox_".concat(optionPriceId));

      if (!element) {
        element = this.shadowRoot.querySelector("#product-radio_".concat(optionPriceId));
      }

      return element;
    }
  }, {
    key: "RemoveEventParticipant",
    value: function () {
      var _RemoveEventParticipant = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(eventParticipantId) {
        var participant, invoiceDetailId, apiInvoiceDetailId;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                participant = this._eventParticipants.find(function (x) {
                  return x.eventParticipantId === eventParticipantId;
                });

                if (participant) {
                  _context14.next = 3;
                  break;
                }

                return _context14.abrupt("return");

              case 3:
                invoiceDetailId = this.GetInvoiceDetailIdFromParticipant(participant);

                if (!invoiceDetailId) {
                  _context14.next = 9;
                  break;
                }

                _context14.next = 7;
                return this.DeleteEventRegistration(invoiceDetailId, eventParticipantId);

              case 7:
                _context14.next = 24;
                break;

              case 9:
                _context14.prev = 9;
                _context14.next = 12;
                return this.GetInvoiceDetailId(eventParticipantId);

              case 12:
                apiInvoiceDetailId = _context14.sent;

                if (!apiInvoiceDetailId) {
                  _context14.next = 18;
                  break;
                }

                _context14.next = 16;
                return this.DeleteEventRegistration(apiInvoiceDetailId, eventParticipantId);

              case 16:
                _context14.next = 19;
                break;

              case 18:
                this.SetMessage("warning", "Unable to find the invoice.");

              case 19:
                _context14.next = 24;
                break;

              case 21:
                _context14.prev = 21;
                _context14.t0 = _context14["catch"](9);
                this.SetMessage("warning", "An error occurred while retrieving the invoice. Please try again.");

              case 24:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[9, 21]]);
      }));

      function RemoveEventParticipant(_x6) {
        return _RemoveEventParticipant.apply(this, arguments);
      }

      return RemoveEventParticipant;
    }()
  }, {
    key: "GetInvoiceDetailIdFromParticipant",
    value: function GetInvoiceDetailIdFromParticipant(participant) {
      if (participant.selectedProductOptions && participant.selectedProductOptions.length > 0) {
        return participant.selectedProductOptions[0].invoiceDetailId;
      }

      return null;
    }
  }, {
    key: "GetInvoiceDetailId",
    value: function () {
      var _GetInvoiceDetailId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(eventParticipantId) {
        var invoiceDetailId;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._eventService.GetBaseInvoiceDetail(eventParticipantId);

              case 2:
                invoiceDetailId = _context15.sent;
                return _context15.abrupt("return", invoiceDetailId > 0 ? invoiceDetailId : null);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function GetInvoiceDetailId(_x7) {
        return _GetInvoiceDetailId.apply(this, arguments);
      }

      return GetInvoiceDetailId;
    }()
  }, {
    key: "DeleteEventRegistration",
    value: function () {
      var _DeleteEventRegistration = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(invoiceDetailId, eventParticipantId) {
        var checkoutApiService, result;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                checkoutApiService = new CheckoutApiService();
                _context16.prev = 1;
                _context16.next = 4;
                return checkoutApiService.DeleteEventRegistration(invoiceDetailId);

              case 4:
                result = _context16.sent;

                if (result.success === true) {
                  this._eventParticipants = this._eventParticipants.filter(function (participant) {
                    return participant.eventParticipantId !== eventParticipantId;
                  });

                  if (this._eventParticipants && this._eventParticipants.length > 0) {
                    this.DrawExistingParticipants();
                  } else {
                    window.location.reload(true);
                  }
                }

                _context16.next = 11;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](1);
                this.SetMessage("warning", "An error occurred while deleting the registration. Please try again.");

              case 11:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[1, 8]]);
      }));

      function DeleteEventRegistration(_x8, _x9) {
        return _DeleteEventRegistration.apply(this, arguments);
      }

      return DeleteEventRegistration;
    }()
    /**
     * Formats the display name of a household member.
     * @param {Object} member - The household member object.
     * @return {string} - The formatted display name.
     */

  }, {
    key: "GetDisplayName",
    value: function GetDisplayName(member) {
      return "".concat(member.lastName, ", ").concat(member.firstName, " ").concat(member.nickName != member.firstName && member.nickName != "" ? "(".concat(member.nickName, ")") : "");
    }
    /**
     * Determines if a household member should be disabled in the dropdown.
     * @param {Object} member - The household member object.
     * @return {boolean} - True if the member should be disabled, false otherwise.
     */

  }, {
    key: "IsMemberDisabled",
    value: function IsMemberDisabled(member) {
      if (this._isMinorRegistration) {
        // Disable if not Minor Child (2) or Adult Child (4)
        var isChild = member.householdPositionId === 2 || member.householdPositionId === 4;
        return !isChild;
      }

      return false;
    }
  }, {
    key: "ValidateDateOfBirth",
    value: function ValidateDateOfBirth() {
      var dateOfBirth = this._$attendeeDateOfBirth.value;

      if (!dateOfBirth) {
        return true; // No validation needed if the field is empty or doesn't exist
      }

      if (new Date(dateOfBirth) > new Date()) {
        this.SetMessage("danger", this._i18n.dateOfBirthFutureError, false);
        this.EnableSubmitButtons();
        return false;
      }

      return true;
    }
  }, {
    key: "UpdateNameFieldsState",
    value: function UpdateNameFieldsState() {
      var isBlankForm = this._$registerAs.value === "Blank Form";
      var fieldsToUpdate = [this._$firstNameText, this._$lastNameText, this._$attendeeFirstNameText, this._$attendeeLastNameText, this._$parentFirstNameText, this._$parentLastNameText];
      fieldsToUpdate.forEach(function (field) {
        if (field) {
          field.disabled = !isBlankForm && field.value.trim() !== "";
        }
      });
    }
  }, {
    key: "ShowUpdateMyInfoContainer",
    value: function ShowUpdateMyInfoContainer() {
      if (this._userIsAuthenticated && this._$registerAs.value !== "Blank Form") {
        this._$updateMyInfoContainer.style.display = "";
      } else {
        this.HideUpdateMyInfoContainer();
      }
    }
  }, {
    key: "HideUpdateMyInfoContainer",
    value: function HideUpdateMyInfoContainer() {
      this._$updateMyInfoContainer.style.display = "none";
      this._$updateMyInfo.checked = false;
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Event Details",
        tag: "mpp-event-details",
        configurationItems: [{
          name: "Return URL",
          attribute: "returnurl",
          description: "URL that defines the path back to the Event Finder. It can be a relative or fully qualified URL.",
          required: true,
          type: "url"
        }, {
          name: "Checkout Target URL",
          attribute: "checkouturl",
          description: "URL that defines the navigation path to the Invoice & Payment Widget. Provides a summary of the invoice and total amount due. Double check to make sure you are working with one of our verified vendors. It can be a relative or fully qualified URL.",
          required: true,
          type: "url"
        }, {
          name: "Opportunity Finder Target URL",
          attribute: "opportunityfinderwidgettargeturl",
          description: "URL that defines the navigation path to the Opportunity Finder when 'Volunteer' is enabled. The Event ID is appended to this path to filter for the specific Event. It can be a relative or fully qualified URL.",
          required: true,
          type: "url"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["checkouturl", "returnurl", "opportunityfinderwidgettargeturl"];
    }
  }]);

  return MppEventDetails;
}(ComponentBase);
MppEventDetails.registerComponent(MppEventDetails.WidgetDetails.tag, MppEventDetails);